/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { SelectionTagSelectionValueTreeList } from '../models/selection-tag-selection-value-tree-list';
import { SingleLineStringTagSuggestionList } from '../models/single-line-string-tag-suggestion-list';
import { stampGetStampTagSelectionValueTreeList } from '../fn/stamp/stamp-get-stamp-tag-selection-value-tree-list';
import { StampGetStampTagSelectionValueTreeList$Params } from '../fn/stamp/stamp-get-stamp-tag-selection-value-tree-list';
import { stampGetStampTagSuggestionList } from '../fn/stamp/stamp-get-stamp-tag-suggestion-list';
import { StampGetStampTagSuggestionList$Params } from '../fn/stamp/stamp-get-stamp-tag-suggestion-list';
import { stampGetStampTagUserSelectionList } from '../fn/stamp/stamp-get-stamp-tag-user-selection-list';
import { StampGetStampTagUserSelectionList$Params } from '../fn/stamp/stamp-get-stamp-tag-user-selection-list';
import { UserSelectionTagUserList } from '../models/user-selection-tag-user-list';

@Injectable({ providedIn: 'root' })
export class StampService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `stampGetStampTagSuggestionList()` */
  static readonly StampGetStampTagSuggestionListPath = '/stamp/single-line-string/suggestion/list';

  /**
   * Get single line string stamp tag suggestions.
   *
   * Get single line string stamp tag suggestions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stampGetStampTagSuggestionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  stampGetStampTagSuggestionList$Response(params?: StampGetStampTagSuggestionList$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleLineStringTagSuggestionList>> {
    const obs = stampGetStampTagSuggestionList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get single line string stamp tag suggestions.
   *
   * Get single line string stamp tag suggestions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stampGetStampTagSuggestionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stampGetStampTagSuggestionList(params?: StampGetStampTagSuggestionList$Params, context?: HttpContext): Observable<SingleLineStringTagSuggestionList> {
    const resp = this.stampGetStampTagSuggestionList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SingleLineStringTagSuggestionList>): SingleLineStringTagSuggestionList => r.body)
    );
  }

  /** Path part for operation `stampGetStampTagSelectionValueTreeList()` */
  static readonly StampGetStampTagSelectionValueTreeListPath = '/stamp/tag/selection-value/tree-list';

  /**
   * Get stamp tag selection values.
   *
   * Get stamp tag selection values
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stampGetStampTagSelectionValueTreeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  stampGetStampTagSelectionValueTreeList$Response(params?: StampGetStampTagSelectionValueTreeList$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectionTagSelectionValueTreeList>> {
    const obs = stampGetStampTagSelectionValueTreeList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get stamp tag selection values.
   *
   * Get stamp tag selection values
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stampGetStampTagSelectionValueTreeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stampGetStampTagSelectionValueTreeList(params?: StampGetStampTagSelectionValueTreeList$Params, context?: HttpContext): Observable<SelectionTagSelectionValueTreeList> {
    const resp = this.stampGetStampTagSelectionValueTreeList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SelectionTagSelectionValueTreeList>): SelectionTagSelectionValueTreeList => r.body)
    );
  }

  /** Path part for operation `stampGetStampTagUserSelectionList()` */
  static readonly StampGetStampTagUserSelectionListPath = '/stamp/tag/user-selection/list';

  /**
   * Get stamp user selection tag users.
   *
   * Get stamp user selection tag users
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `stampGetStampTagUserSelectionList()` instead.
   *
   * This method doesn't expect any request body.
   */
  stampGetStampTagUserSelectionList$Response(params?: StampGetStampTagUserSelectionList$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSelectionTagUserList>> {
    const obs = stampGetStampTagUserSelectionList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get stamp user selection tag users.
   *
   * Get stamp user selection tag users
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `stampGetStampTagUserSelectionList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  stampGetStampTagUserSelectionList(params?: StampGetStampTagUserSelectionList$Params, context?: HttpContext): Observable<UserSelectionTagUserList> {
    const resp = this.stampGetStampTagUserSelectionList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UserSelectionTagUserList>): UserSelectionTagUserList => r.body)
    );
  }

}
